import React, { useState, useEffect } from "react";
import { Col, Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import "rc-datepicker/lib/style.css";
import { getMenuData, getlistClass, getEvaluations, getEntrypointsHasElements } from "../../../../../services/NexiDigitalAPI";
import FiltroWrapper from "../../../Components/FiltroWrapper";
import styles from "../../styles.module.scss";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import CatalogModal from "containers/PeopleCraft/NodeManagerV2/CatalogModal";
import ClearTrainingButton from "../../../Components/ClearTrainingButton";
import useSelectOptions from "hooks/useSelectOptions";
const Filter = ({ actionFilter, loading, expanded, downloadEvent }) => {
  const initialStateSelect = [
    {
      value: "all",
      label: "Todas",
    },
  ];
  const initialFormStates = {
    idEvaluation: "",
    idTeam: "all",
    nodeCode: "all",
    idCompany: getMenuData().idCompany,
    offset: 0,
    limit: 10,
  };
  const [formData, setFormData] = useState(initialFormStates);
  const [evaluations, setEvaluations] = useState(initialStateSelect);
  const [learnings, setLearnings] = useState(initialStateSelect);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [showCatalog, setShowCatalog] = useState(false);
  const [loadingLearnings, setLoadingLearnings] = useState(false);
  const [loadingEvaluations, setLoadingEvaluations] = useState(false);

  const evaluationOptions = useSelectOptions(evaluations, loadingEvaluations);
   const learningOptions = useSelectOptions(learnings, loadingLearnings);
  const onClear = () => {
    setSelectedTraining(null);
    setFormData((prev) => ({ ...prev, nodeCode: null, idTeam: "all", idEvaluation: "all" }));
    setLearnings(initialStateSelect);
    setEvaluations(initialStateSelect);
  };

   const  _getEvaluations = async (params) =>  {
      setLoadingEvaluations(true)
    try {
      const { result } = await getEvaluations({
        idCompany: getMenuData().idCompany,
        evaluationType: "IMPACT",
        ...params
      });

      if (result.length) {
        const formatedData = result.map(({ idEvaluation, title }) => {
          return {
            value: idEvaluation,
            label: title,
          };
        });
       return setEvaluations([...initialStateSelect, ...formatedData]);
      }else{
        setEvaluations([...initialStateSelect])
      }
    } catch (err) {
      console.log(err);
    }finally{
        setLoadingEvaluations(false)
    }
  }

  async function getLearnings(nodeCode) {
    try {
      setLoadingLearnings(true)
      const learningResBase = await getlistClass(nodeCode);
      const learningRes = learningResBase.result;

      if (learningRes.length) {
        const formatedData = learningRes.map(({ idTeam, name }) => {
          return {
            value: idTeam,
            label: name,
          };
        });
        return setLearnings([...initialStateSelect, ...formatedData]);
      } else {
        return setLearnings(initialStateSelect);
      }
    } catch (err) {
      console.log(err);
    }finally{
      setLoadingLearnings(false)

    }
  }

  function handleFilter() {
    return actionFilter({
      ...formData,
      idTeam: formData.idTeam === "all" ? undefined : formData.idTeam,
      nodeCode: formData.nodeCode === "all" ? undefined : formData.nodeCode,
      idEvaluation: formData.idEvaluation === "all" ? undefined : formData.idEvaluation,
      idCompany: getMenuData().idCompany,
    });
  }

  const handleChangeSelect = async ({ target }) => {
    console.log(target)
    const { name, value } = target;
    if(name === "evaluations"){
      setFormData((prevData) => ({
        ...prevData,
        idEvaluation: value,
      }));

    }
    if(name ==="learnings"){
      setFormData((prevData) => ({
        ...prevData,
        idTeam: value,
      }));
    }

  };

  const handleChangeTraining = async (node) => {
    const code = node?.originCode ?? node?.nodeCode;
    const target = { ...initialStateSelect[0], name: initialStateSelect[0].label }
    console.log(target)

    handleChangeSelect({target: { ...initialStateSelect[0], name: 'evaluations' }});
    handleChangeSelect({target: { ...initialStateSelect[0], name: 'learnings' }});
    setSelectedTraining(node);
    setFormData((prev) => ({
      ...prev,
      nodeCode: code || "all",
    }));
    setShowCatalog(false);

    if (code) {
      _getEvaluations({ nodeCode: code });
      getLearnings({ nodeCode: code });
    } else {
      setLearnings(initialStateSelect);
      setEvaluations(initialStateSelect);
    }
  }

  function updateStates() {
    setFormData(initialFormStates);
    setLearnings(initialStateSelect);
    setEvaluations(initialStateSelect);
  }

  useEffect(() => {
    if (expanded) {
      updateStates();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expanded]);
  return (
    <FiltroWrapper>
      <Form style={{ marginTop: 30, marginBottom: 30 }}>
        <Form.Row className="align-items-end">
          <Col xs={12} md={3} lg={3} className={styles.customFormSpace}>
            <Form.Label htmlFor="trainings">Treinamento*</Form.Label>
            <div style={{ position: "relative" }}>
              <div
                className={styles.trainingSelectDiv}
                onClick={() => setShowCatalog(true)}
                title={
                  selectedTraining
                    ? `${selectedTraining.nodeCode} - ${selectedTraining.title}`
                    : "Selecionar treinamento"
                }
              >
                <span className={styles.trainingSelectText}>
                  {selectedTraining
                    ? `${selectedTraining.nodeCode} - ${selectedTraining.title}`
                    : "Selecionar treinamento"}
                </span>
                {selectedTraining && (
                  <span style={{ marginLeft: 8, flexShrink: 0 }}>
                    <ClearTrainingButton
                      onClear={onClear}
                      disabled={loading}
                      className={styles.cleanTrainingButton}
                    />
                  </span>
                )}
              </div>
            </div>
            {showCatalog && (
              <CatalogModal
                denyAction={() => setShowCatalog(false)}
                title="Selecione o treinamento"
                returnNodeData={handleChangeTraining}
                isSimpleSelect={true}
                nodeType={"LEARNING"}
                onlyEntrypoints={true}
                requestListNode={() =>
                  getEntrypointsHasElements({
                    entityType: "IMPACT_EVALUATION",
                  })
                }
                disableRequestChildNodes={true}
              />
            )}
          </Col>
          <Col xs={12} md={3} lg={3} className={styles.customFormSpace}>
            <Form.Label htmlFor="evaluations">Avaliação</Form.Label>
            <Form.Control
              id="evaluations"
              name="evaluations"
              as="select"
              disabled={!selectedTraining  || loading}
              value={formData.idEvaluation}
              onChange={handleChangeSelect}
            >
              {evaluationOptions}
            </Form.Control>
          </Col>

          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Label htmlFor="learnings">Turma</Form.Label>
            <Form.Control
              id="learnings"
              name="learnings"
              as="select"
              value={formData.idTeam}
              disabled={!selectedTraining || loading}
              onChange={handleChangeSelect}
            >
              {learningOptions}
            </Form.Control>
          </Col>
          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Group className="mb-0">
              <ButtonWithLoading
                disabled={!formData.idEvaluation}
                onClickHandler={handleFilter}
                loading={loading}
                text={
                  <>
                    Aplicar filtro <FaFilter style={{ marginLeft: 5 }} />
                  </>
                }
                style={{ width: "100%" }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Group className="mb-0">
              <ButtonWithLoading
                disabled={!selectedTraining}
                onClickHandler={downloadEvent}
                loading={loading}
                text={<>Download da planilha</>}
                style={{ width: "100%", backgroundColor: "#0d6efd", borderColor: "#0d6efd" }}
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    </FiltroWrapper>
  );
};

export default Filter;
